// Recents bridge backed by web_recents joined to web_scripts.
// Returns rows shaped like Electron's recent.js entries:
// `{ filePath, name, lastOpened }`.

export function buildRecentHandlers({ supabase }) {
  return {
    async listRecent() {
      if (!supabase) return [];
      try {
        const { data, error } = await supabase
          .from('web_recents')
          .select('opened_at, script_id, web_scripts(id, title, updated_at)')
          .order('opened_at', { ascending: false })
          .limit(10);
        if (error) throw error;
        return (data || [])
          .filter((row) => row.web_scripts)
          .map((row) => ({
            filePath: row.script_id,
            name: row.web_scripts.title || 'Untitled',
            lastOpened: row.opened_at,
          }));
      } catch (err) {
        console.error('[bridge.recent.listRecent]', err);
        return [];
      }
    },
  };
}
